module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_kimono-046b13796a68dd0639fa8875a6a1dfc8.webp";